import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Button, Breadcrumbs, Input } from '../../../components/UI/ComponentsUI';
import { translate, showMessageToastCustom, isNullOrEmpty } from '../../../utils/util';
import { validateInputsRequired, onValueChange } from '../../../utils/handleChangeHooks';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import ModalUploadAlternativeMdrPartNumber from './ModalUploadAlternativeMdrPartNumber';

const AlternativeMdrPartnumberInsert = (props) => {
    const update = props.location?.state?.update;
    const [alternativeMdrPartnumber, setAlternativeMdrPartnumber] =
        useState(props.location?.state?.update && props.alternativeMdrPartnumber ?
            props.alternativeMdrPartnumber :
            {
                partNumberCode: ""
            });
    const [openModal, setOpenModal] = useState(false);
    const [mdrList, setMdrList] = useState(props.location?.state?.update && props.alternativeMdrPartnumber ? props.alternativeMdrPartnumber?.alternativeMdrPartnumberItems : []);

    const onChange = (event) => {
        onValueChange(event, alternativeMdrPartnumber, setAlternativeMdrPartnumber);
    };

    const addItem = () => {
        if (validateInputsRequired("formAlternativeMdrPartnumber")) {
            if (mdrList.find((f) => f.mdr === alternativeMdrPartnumber?.mdr)) {
                return showMessageToastCustom(translate('warning', 'general'), `MDR ${alternativeMdrPartnumber?.mdr} já adicionado!`, 3000, 'mdi mdi-alert-circle-outline red-text');
            }
            mdrList.push({ mdr: alternativeMdrPartnumber?.mdr, order: mdrList.length + 1 });
            setMdrList([...mdrList]);
            alternativeMdrPartnumber.mdr = "";
            setAlternativeMdrPartnumber({ ...alternativeMdrPartnumber })
        }
    }

    const alterOrderItem = (item, up) => {
        if (up) {
            if (item.order === 1) {
                return;
            }
            const aux = mdrList.find(f => f.order === item.order).order;
            mdrList.find(f => f.order === item.order && item.mdr === f.mdr).order = item.order - 1;
            mdrList.find(f => f.order === (aux - 1) && f.mdr !== item.mdr).order = aux
        } else {
            if (item.order === mdrList.length) {
                return;
            }
            const aux = mdrList.find(f => f.order === item.order).order;
            mdrList.find(f => f.order === item.order && item.mdr === f.mdr).order = item.order + 1;
            mdrList.find(f => f.order === (aux + 1) && f.mdr !== item.mdr).order = aux;
        }

        setMdrList([...mdrList])
    }

    const onConfirm = () => {
        if (isNullOrEmpty(alternativeMdrPartnumber.partNumberCode)) {
            return showMessageToastCustom(translate('warning', 'general'), `Informe o Desenho`, 3000, 'mdi mdi-alert-circle-outline red-text');
        }

        if (mdrList.length === 0) {
            return showMessageToastCustom(translate('warning', 'general'), `Informe um MDR`, 3000, 'mdi mdi-alert-circle-outline red-text');
        }

        var obj = {
            ...alternativeMdrPartnumber,
            alternativeMdrPartnumberItems: mdrList
        }

        if (update) {

            props.updateAlternativeMdrPartnumber(obj, (response) => {
                if (!response) {
                    showMessageToastCustom(translate('warning', 'general'), translate('failed-to-update', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                } else {
                    showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    props.history.go(-1);
                }
            });
        } else {
            props.insertAlternativeMdrPartnumber(obj, (response) => {
                if (!response) {
                    showMessageToastCustom(translate('warning', 'general'), translate('failed-to-include', 'general'), 3000, 'mdi mdi-alert-circle-outline red-text');
                } else {
                    showMessageToastCustom(translate('general.info'), translate('sucess-to-include', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    props.history.go(-1);
                }
            });
        }
    };


    const removeItem = (item) => {
        let list = [];
        Object.assign(list, mdrList);
        const findIndex = list.indexOf(item);
        list.splice(findIndex, 1);

        var listOrder = list.sort((a, b) => {
            if (a.order < b.order) { return -1; }
            if (a.order > b.order) { return 1; }
            return 0;
        })

        for (let index = 0; index < listOrder.length; index += 1) {
            listOrder[index].order = index + 1;
        }

        setMdrList(listOrder);
    }

    const title = { icon: "mdi mdi-clipboard-check-outline", label: translate('physical-confirmation:label-alternativeMdrPartnumber') };
    const subtitles = () => {
        let subtitlesItems = [];
        subtitlesItems = [...subtitlesItems, { label: update ? translate('menu.update', 'configuration') : translate('menu.insert', 'configuration') }]
        return subtitlesItems;
    }

    return (
        <div>
            <Breadcrumbs id="alternativemdrpartnumberinsert" title={title} subtitles={subtitles()} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <form id="formAlternativeMdrPartnumber" className="col s12">
                                <div className="row" style={{ padding: '10px' }}>
                                    <div className="input-field no-padding col s12">
                                        <Input
                                            id="partNumberCode"
                                            name='partNumberCode'
                                            label={translate('part-number', 'physical-confirmation')}
                                            type="text"
                                            value={alternativeMdrPartnumber?.partNumberCode || ''}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="input-field no-padding col s9">
                                        <Input
                                            id="mdr"
                                            name='mdr'
                                            label={translate('mdr', 'physical-confirmation')}
                                            type="text"
                                            value={alternativeMdrPartnumber?.mdr || ''}
                                            onChange={onChange}
                                            required
                                        />
                                    </div>
                                    <div className="col s2" style={{ paddingTop: '17px' }}>
                                        <button
                                            className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                            type="button"
                                            onClick={() => addItem()}
                                        >
                                            <i className={`mdi mdi mdi-plus`} />
                                        </button>
                                    </div>
                                </div>
                                {!update &&
                                    <div className="input-field no-padding  col s1">
                                        <button
                                            className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                            type="button"
                                            onClick={() => setOpenModal(true)}>
                                            <i className="Small material-icons">cloud_upload</i>
                                        </button>
                                    </div>
                                }
                            </form>
                            {mdrList.length > 0 &&
                                <div>
                                    {mdrList.sort((a, b) => {
                                        if (a.order < b.order) { return -1; }
                                        if (a.order > b.order) { return 1; }
                                        return 0;
                                    }).map((item) => {
                                        return (
                                            <div className="col s12" key={item.order}>
                                                <i onClick={() => removeItem(item)} className="mdi mdi-24px mdi-delete-circle" style={{ cursor: 'pointer', color: 'red' }} />
                                                <label className="list sixth-text-color">{item.mdr} - {item.order}</label>
                                                {
                                                    mdrList.length !== item.order &&
                                                    <i onClick={() => {
                                                        alterOrderItem(item, false)
                                                    }
                                                    } className="mdi mdi-24px mdi-arrow-down-bold" style={{ cursor: 'pointer', color: mdrList.length === item.order ? 'gray' : 'coral' }} />
                                                }
                                                {
                                                    item.order !== 1 &&
                                                    <i onClick={() => {
                                                        alterOrderItem(item, true)
                                                    }} className="mdi mdi-24px mdi-arrow-up-bold" style={{ cursor: 'pointer', color: item.order === 1 ? 'gray' : 'green' }} />
                                                }

                                            </div>
                                        );
                                    })}
                                </div>
                            }
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={() => onConfirm()} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <ModalUploadAlternativeMdrPartNumber
                open={openModal}
                id="ModalUploadMdrPartnumbers"
                onCancel={() => setOpenModal(false)}
                onClose={() => setOpenModal(false)}
                onConfirm={() => setOpenModal(false)}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div >
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        alternativeMdrPartnumber: state.physicalConfirmationReducer.alternativeMdrPartnumber
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        insertAlternativeMdrPartnumber: (alternativeMdrPartnumber, callback) => {
            dispatch(PhysicalConfirmationService.insertAlternativeMdrPartnumber(alternativeMdrPartnumber, callback));
        },
        updateAlternativeMdrPartnumber: (alternativeMdrPartnumber, callback) => {
            dispatch(PhysicalConfirmationService.updateAlternativeMdrPartnumber(alternativeMdrPartnumber, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AlternativeMdrPartnumberInsert));